export default __webpack_public_path__ + "static/media/czLogo.1d57ac18.png";